import { Link, Navigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGetCatalogQuery } from '@platform/state/api';
import { todayIso } from '@platform/core/lib/format';
import { routes } from '@platform/core/lib/routes';
import { useWorkspaceParams } from '@platform/hooks/useWorkspaceParams';
import { useWorkspaceMeta } from '../../shell/useWorkspaceMeta';
import { HomeViewGroup } from './HomeViewGroup';
import { inHomeView, isHomeView } from './homeViews';
import { workGroups } from './workGroups';
import { useMyWork } from './useMyWork';
import './work.css';

/**
 * Подання «Моя робота» Головної (прототип v4 homeView, G:L1580–1625): «← Головна», заголовок («Призначені мені», «Термін цього тижня»,
 * «Прострочено»), «N відкритих елементів у M модулях · простір», групи за типами записів (workGroups) з GET /me/work; порожньо — «Тут порожньо — чудово.».
 */
export function HomeViewPage() {
  const { t } = useTranslation();
  const { view } = useParams();
  const { ws } = useWorkspaceParams();
  const { workspace } = useWorkspaceMeta(ws);
  const { data: catalog } = useGetCatalogQuery({ workspaceId: ws });
  const { items } = useMyWork(ws);
  if (!isHomeView(view)) return <Navigate to={routes.home()} replace />;
  const today = todayIso();
  const shown = (items ?? []).filter((r) => inHomeView(r, view, today));
  const groups = workGroups(shown, catalog);
  return (
    <div className="hv-page">
      <Link className="hv-back" to={routes.home()}>{t('homeViews.back')}</Link>
      <div className="hv-head">
        <h1>{t(`homeViews.${view}`)}</h1>
        <div className="muted">
          {items ? t('homeViews.sub', { items: t('homeViews.items', { count: shown.length }), modules: t('homeViews.modules', { count: groups.length }), ws: workspace?.name ?? '' }) : t('homeViews.loading')}
        </div>
      </div>
      {groups.map((g) => <HomeViewGroup key={g.recordType} ws={ws} group={g} today={today} />)}
      {items && !shown.length && <div className="hv-empty">{t('homeViews.empty')}</div>}
    </div>
  );
}
